var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "rounded position-relative pl-2 pr-2 pt-2 mb-4",
          style: { background: _vm.reply.stance_colour }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _c(
              "blockquote",
              {
                staticClass: "twitter-tweet",
                attrs: { "data-conversation": "none", "data-lang": "en" }
              },
              [
                _c(
                  "Tweet",
                  {
                    attrs: {
                      id: _vm.reply.id_str,
                      options: { conversation: "none" }
                    }
                  },
                  [_c("custom-tweet-display", { attrs: { tweet: _vm.reply } })],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mr-1",
              style: {
                background:
                  "linear-gradient(" +
                  _vm.reply.stance_colour +
                  " , white 30%)",
                display: "inline-block"
              }
            },
            [
              _c(
                "div",
                { staticClass: "pl-2 pr-2 pt-2 " },
                [
                  _vm.reply.auto_stance_available
                    ? [
                        _c("img", {
                          staticStyle: { height: "2em" },
                          attrs: {
                            src: "/static/images/robot.svg",
                            alt: "Our algorithm says the stance is ",
                            title: "Our algorithm says the stance is "
                          }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.reply.stance_text) +
                            "\n                "
                        )
                      ]
                    : [
                        _c("img", {
                          staticStyle: { height: "2em" },
                          attrs: {
                            src: "/static/images/robot.svg",
                            alt: "Our algorithm says the stance is ",
                            title: "Our algorithm says the stance is "
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "badge badge-secondary",
                            attrs: { title: _vm.reply.stance_badge_text }
                          },
                          [_vm._v(_vm._s(_vm.reply.stance_text))]
                        )
                      ]
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pl-2 pr-2 pt-2 mr-1",
              staticStyle: { background: "white", display: "inline-block" }
            },
            [
              _c("div", [
                _c("img", {
                  staticClass: "mr-1",
                  staticStyle: { height: "2em" },
                  attrs: {
                    src: "/static/images/opinion.svg",
                    alt: "Users voted for the following stance ",
                    title: "Users voted for the following stance "
                  }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "stancevote-btn supportstance-btn",
                    attrs: {
                      href: "#",
                      "data-stance": "support",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: _vm.supportTitle
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.voteForStance("support")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.supportNumVotes))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "stancevote-btn denystance-btn",
                    attrs: {
                      href: "#",
                      "data-stance": "deny",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: _vm.denyTitle
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.voteForStance("deny")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.denyNumVotes))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "stancevote-btn commentstance-btn",
                    attrs: {
                      href: "#",
                      "data-stance": "comment",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: _vm.commentTitle
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.voteForStance("comment")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.commentNumVotes))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "stancevote-btn questionstance-btn",
                    attrs: {
                      href: "#",
                      "data-stance": "question",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: _vm.questionTitle
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.voteForStance("question")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.questionNumVotes))]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pl-2 pr-2 pt-2 mr-1",
              staticStyle: { background: "white", display: "inline-block" }
            },
            [
              _c("div", [
                this.reply.lang != "und"
                  ? _c("span", [_vm._v("Language: " + _vm._s(this.reply.lang))])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.reply.replies && _vm.reply.replies.length > 0 && _vm.displaySubreplies
        ? _vm._l(_vm.reply.replies, function(subReply) {
            return _c(
              "div",
              { staticClass: "subtweet-container" },
              [
                _c("tweet-reply", {
                  key: subReply.id_str,
                  attrs: { reply: subReply }
                })
              ],
              1
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "help-btn",
        attrs: { "data-toggle": "modal", "data-target": "#stanceHelpModal" }
      },
      [
        _c("img", {
          attrs: {
            src: "/static/images/help.svg",
            alt: "Explanation of stance classification",
            title: "Explanation of stance classification"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }